import { IJob } from "../types/IJob";
import { ILoggedHour } from "../types/ILoggedHour";

export const addOrUpdateJob = (job: IJob, jobs: Array<IJob>): Array<IJob> => {
  const index = jobs.findIndex((f: IJob) => job.jobNumber === f.jobNumber);
  //Not found, add on end.
  if (-1 === index) {
    return [...jobs, job];
  }
  //found, so return:
  //Clone of items before item being update.
  //updated item
  //Clone of items after item being updated.
  return [...jobs.slice(0, index), job, ...jobs.slice(index + 1)];
};

export const getStartedOperation = (job: IJob): string | undefined => {
  const started = job.openLoggedJobs.find(
    (f: ILoggedHour) => job.jobNumber === f.job
  );
  //Not found, add on end.
  return started?.operation;
};

export const getJobProgress = (job: IJob): number => {
  if (job.minutesLogged === 0 || job.minutesPlanned === 0) {
    return 0;
  }

  return Math.floor((100 * job.minutesLogged) / job.minutesPlanned);
};

export const getMinutesRemaining = (job: IJob): number => {
  return Math.floor(job.minutesPlanned - job.minutesLogged);
};

export const IsJobDue = (job: IJob): boolean => {
  const dueDate = new Date();
  dueDate.setDate(dueDate.getDate() + 7);
  return new Date(job.scheduledEndDate) < dueDate;
}
